import { CCAgentImage1, CCAgentImage2, CCAgentImage3 } from 'assets';
import { Col } from 'components';
import { LayoutProps, SpaceProps } from 'mymoria-ui/interfaces';
import { css, styled } from 'mymoria-ui/utils';
import { FunctionComponent } from 'react';

const ccAgentsData = [
  {
    image: CCAgentImage1,
    style: {
      bottom: '0%',
      left: '6%',
      width: '60%',
    },
  },
  {
    image: CCAgentImage2,
    style: {
      right: '0%',
      top: '8%',
      width: '58%',
    },
  },
  {
    image: CCAgentImage3,
    style: {
      left: '2%',
      top: '0%',
      width: '46%',
    },
  },
];

export interface CCAgentsProps extends SpaceProps, LayoutProps {
  className?: string;
}

const Container = styled(Col)`
  position: relative;
  aspect-ratio: 1;
`;

type ImageCircleProps = {
  number: number;
};

const ImageCircle = styled.div<ImageCircleProps>(
  ({ number }) => css`
    position: absolute;
    clip-path: circle();
    ${ccAgentsData[number].style};
    aspect-ratio: 1;
    padding: 0rem;
  `,
);

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  clip-path: circle();
`;

const CCAgents: FunctionComponent<CCAgentsProps> = props => (
  <Container width={['30%', '25%']} px={0} {...props}>
    {ccAgentsData.map((agent, index) => (
      <ImageCircle key={index} number={index}>
        <StyledImage alt="Customer Care Agent" src={agent.image} />
      </ImageCircle>
    ))}
  </Container>
);

export default CCAgents;
